import { get } from "lodash";
import moment from "moment-timezone";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Table, Icon } from "semantic-ui-react";

import ActionDropdownMenu from "../actionDropdownMenu/ActionDropdownMenu.jsx";
import LinkWithReset from "../utils/LinkWithReset.jsx";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ScheduleRow extends PureComponent {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  onDelete = () => {
    const { schedule, onDelete } = this.props;
    onDelete(schedule["@id"]);
  };

  getWeekString() {
    const { schedule } = this.props;

    let weeks = "";

    if (!schedule) return weeks;

    weeks += schedule.sunday ? " S" : "";
    weeks += schedule.monday ? " M" : "";
    weeks += schedule.tuesday ? " T" : "";
    weeks += schedule.wednesday ? " W" : "";
    weeks += schedule.thursday ? " T" : "";
    weeks += schedule.friday ? " F" : "";
    weeks += schedule.saturday ? " S" : "";

    // remove leading space
    return weeks.substring(1);
  }

  getDateString(isoDate) {
    const { timezone } = this.props.schedule;
    if (!isoDate || !timezone) return "-";
    return moment(isoDate).tz(timezone.value).format("DD-MM-YY");
  }

  render() {
    const { schedule, copy } = this.props;

    return (
      <Table.Row key={schedule.id} textAlign="center">
        <Table.Cell textAlign="left">
          <LinkWithReset to={schedule["@id"]} className="table-link">
            <Icon name="folder" /> {schedule.name}
          </LinkWithReset>
        </Table.Cell>
        <Table.Cell textAlign="left" collapsing>
          {get(schedule, "timezone.value", null)}
        </Table.Cell>
        <Table.Cell collapsing>
          {this.getDateString(schedule.startAt)}
        </Table.Cell>
        <Table.Cell collapsing>{this.getDateString(schedule.endAt)}</Table.Cell>
        <Table.Cell collapsing>{this.getWeekString()}</Table.Cell>
        <Table.Cell collapsing>
          <ActionDropdownMenu
            data={schedule}
            editPath={schedule["@id"]}
            onDelete={this.onDelete}
            copy={copy("basic_resource_actions")}
          />
        </Table.Cell>
      </Table.Row>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ScheduleRow);
